<template>
  <Icon>
    <svg slot="svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="20" viewBox="0 0 14 20">
      <defs>
        <path :id="`logout@3x-a${randomId}`" d="M17,10.11 L17,7 C17,4.243 14.757,2 12,2 C9.243,2 7,4.243 7,7 L7,10.11 C5.765,11.373 5,13.098 5,15 C5,18.86 8.141,22 12,22 C15.859,22 19,18.86 19,15 C19,13.098 18.235,11.373 17,10.11 Z M12,4 C13.654,4 15,5.346 15,7 L15,8.686 C14.09,8.25 13.074,8 12,8 C10.926,8 9.91,8.25 9,8.686 L9,7 C9,5.346 10.346,4 12,4 Z M12,20 C9.243,20 7,17.757 7,15 C7,12.243 9.243,10 12,10 C14.757,10 17,12.243 17,15 C17,17.757 14.757,20 12,20 Z M12,18 C12.8284271,18 13.5,17.3284271 13.5,16.5 C13.5,15.6715729 12.8284271,15 12,15 C11.1715729,15 10.5,15.6715729 10.5,16.5 C10.5,17.3284271 11.1715729,18 12,18 Z"/>
      </defs>
      <g fill="none" fill-rule="evenodd" transform="translate(-5 -2)">
        <rect width="24" height="24"/>
        <mask :id="`logout@3x-b${randomId}`" fill="#fff">
          <use :xlink:href="`#logout@3x-a${randomId}`"/>
        </mask>
        <g :fill="fill" :mask="`url(#logout@3x-b${randomId})`">
          <rect width="24" height="24"/>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsLockIcon",
  props: {
    fill: {
      type: String,
      default: "#43CEA2"
    }
  },
  data() {
    return {
      randomId: Math.random()
        .toString(36)
        .substring(7)
    };
  },
  components: {
    Icon
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-lock-icon.vue